import { Info } from '../design-system';
import { PROTECTION_OPT_OUT_WARNING } from './protection';
import { ProtectionCheckbox } from './ProtectionCheckbox';

export interface ProtectionOptOutWarningProps {
  /** The opt-out acknowledgement state — lifted to the form so Submit can
   *  gate on it. */
  acknowledged: boolean;
  onAcknowledgedChange: (next: boolean) => void;
}

/**
 * Shown when the player picks a shipping option weaker than the protection the
 * backend requires for the shipment. A warning bar (amber-tinted glass + warn
 * icon + copy) plus an acknowledgement checkbox; the parent blocks Submit
 * until `acknowledged` is true and passes the flag to `createPoolShipping`.
 *
 * All colours via `--co-ProtectionOptOut-*` / `--co-ProtectionAck-*` with hex
 * fallbacks.
 */
export function ProtectionOptOutWarning({
  acknowledged,
  onAcknowledgedChange,
}: ProtectionOptOutWarningProps) {
  return (
    <div
      data-co-component="ProtectionOptOutWarning"
      role="alert"
      className="flex flex-col gap-3 rounded-[16px] border p-3"
      style={{
        background:
          'var(--co-ProtectionOptOut-fill, rgba(245,158,11,0.10))',
        borderColor: 'var(--co-ProtectionOptOut-border, rgba(245,158,11,0.45))',
      }}
    >
      <div className="flex items-start gap-2.5">
        <span
          aria-hidden
          className="mt-0.5 shrink-0"
          style={{ color: 'var(--co-ProtectionOptOut-iconColor, #F59E0B)' }}
        >
          <Info size={18} strokeWidth={1.8} />
        </span>
        <p
          className="text-[13px] font-medium leading-[18px]"
          style={{ color: 'var(--co-ProtectionOptOut-textColor, rgba(255,255,255,0.90))' }}
        >
          {PROTECTION_OPT_OUT_WARNING}
        </p>
      </div>

      <ProtectionCheckbox
        id="protection-opt-out-ack"
        checked={acknowledged}
        onChange={onAcknowledgedChange}
      >
        I understand and accept the risk
      </ProtectionCheckbox>
    </div>
  );
}
